'use strict';


function OverviewExpand($expandNode) {
  this.$trigger = $expandNode.find('.js-overview-trigger');
  this.$contentCollapsed = $expandNode.find('.js-overview-full');
  this.labelCollapsed = this.$contentCollapsed.data('overview-label-more');
  this.labelExpanded = this.$contentCollapsed.data('overview-label-less');
  this.visibility = false;
  this.activeClass = "is-expanded";

  this.bindEvents();
}

OverviewExpand.prototype.expandOverview = function readMore() {
  this.visibility = true;

  this.$contentCollapsed.slideDown();

  this.$trigger.addClass(this.activeClass).text(this.labelExpanded);
}

OverviewExpand.prototype.collapseOverview = function readLess() {
  this.visibility = false;

  this.$contentCollapsed.slideUp();

  this.$trigger.removeClass(this.activeClass).text(this.labelCollapsed);
}

OverviewExpand.prototype.toggleVisibility = function toggle() {
  (this.visibility === true )  ? this.collapseOverview() :  this.expandOverview();
}

OverviewExpand.prototype.bindEvents = function bindEvents() {

  var _self = this;

  _self.$trigger.on('click.overviewExpand', function(ev){
    ev.preventDefault();

    _self.toggleVisibility();
  });
}


jQuery.fn.InitializeExpandNodes = function () {
    var $overviewExpandNode = $(this); 

    if ($overviewExpandNode.length) {
        //collection of nodes that will house all expands modules
        var moduleExpandableNodes = {};

        for (var i = 0, len = $overviewExpandNode.length; i < len; i++) {
            moduleExpandableNodes['module-id-' + i] = new OverviewExpand($overviewExpandNode.eq(i));
        }
    }
}

$(function () {

    var $overviewExpandNode = $('.js-overview-expand');

    $overviewExpandNode.InitializeExpandNodes();

});